import React, { useState } from 'react';
import axios from 'axios';
import { useToast } from '../components/ui';

const AIInsights = () => {
  const { toast } = useToast();
  const [menuOptimization, setMenuOptimization] = useState('');
  const [demandForecast, setDemandForecast] = useState('');
  const [customerInsights, setCustomerInsights] = useState('');
  const [loading, setLoading] = useState({ menu: false, forecast: false, insights: false });
  const [forecastDate, setForecastDate] = useState('');

  const getMenuOptimization = async () => {
    setLoading({ ...loading, menu: true });
    try {
      const res = await axios.post('/api/ai/menu-optimization', {}, 
        { headers: { 'x-auth-token': localStorage.getItem('token') } });
      setMenuOptimization(res.data.insights);
    } catch (err) { toast.error(err.response?.data?.msg || 'Error getting AI insights'); }
    setLoading({ ...loading, menu: false });
  };

  const getDemandForecast = async () => {
    setLoading({ ...loading, forecast: true });
    try {
      const res = await axios.post('/api/ai/demand-forecast', { date: forecastDate }, 
        { headers: { 'x-auth-token': localStorage.getItem('token') } });
      setDemandForecast(res.data.forecast);
    } catch (err) { toast.error(err.response?.data?.msg || 'Error getting forecast'); }
    setLoading({ ...loading, forecast: false });
  };

  const getCustomerInsights = async () => {
    setLoading({ ...loading, insights: true });
    try {
      const res = await axios.post('/api/ai/customer-insights', {}, 
        { headers: { 'x-auth-token': localStorage.getItem('token') } });
      setCustomerInsights(res.data.insights);
    } catch (err) { toast.error(err.response?.data?.msg || 'Error getting insights'); }
    setLoading({ ...loading, insights: false });
  };

  return (
    <>
      <h1 className="text-3xl font-bold mb-6">AI Insights (Powered by Gemini)</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-bold mb-4">Menu Optimization</h2>
          <button onClick={getMenuOptimization} disabled={loading.menu}
            className="w-full bg-purple-600 text-white py-2 rounded mb-4">
            {loading.menu ? 'Analyzing...' : 'Analyze Menu'}
          </button>
          {menuOptimization && (
            <div className="bg-gray-50 p-4 rounded text-sm whitespace-pre-wrap">{menuOptimization}</div>
          )}
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-bold mb-4">Demand Forecast</h2>
          <input type="date" value={forecastDate} onChange={(e) => setForecastDate(e.target.value)}
            className="w-full p-2 border rounded mb-4" />
          <button onClick={getDemandForecast} disabled={loading.forecast || !forecastDate}
            className="w-full bg-blue-600 text-white py-2 rounded mb-4">
            {loading.forecast ? 'Forecasting...' : 'Get Forecast'}
          </button>
          {demandForecast && (
            <div className="bg-gray-50 p-4 rounded text-sm whitespace-pre-wrap">{demandForecast}</div>
          )}
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-bold mb-4">Customer Insights</h2>
          <button onClick={getCustomerInsights} disabled={loading.insights}
            className="w-full bg-green-600 text-white py-2 rounded mb-4">
            {loading.insights ? 'Analyzing...' : 'Get Insights'}
          </button>
          {customerInsights && (
            <div className="bg-gray-50 p-4 rounded text-sm whitespace-pre-wrap">{customerInsights}</div>
          )}
        </div>
      </div>
    </>
);
};

export default AIInsights;
